module.exports = __webpack_public_path__ + "static/media/intro-bg-face.1bede615.svg";